// Ícone SVG inline da bandeira Banescard (sem requisição HTTP)
import * as React from 'react';

export function BanescardIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 48 32" role="img" aria-label="Banescard" {...props}>
      <rect width="48" height="32" rx="4" fill="#009639" />
      <text
        x="24"
        y="15"
        textAnchor="middle"
        fontFamily="Arial, Helvetica, sans-serif"
        fontWeight="800"
        fontSize="7"
        fill="#fff"
      >
        Banes
      </text>
      <text
        x="24"
        y="23"
        textAnchor="middle"
        fontFamily="Arial, Helvetica, sans-serif"
        fontWeight="800"
        fontSize="7"
        fill="#FFD400"
      >
        card
      </text>
    </svg>
  );
}
